import Layout from '~/layouts/default';
import Seo from '~/components/seo';
import Section from '~/components/tos/section';

export default function Page() {
  return (
    <>
      <Layout>
        <Seo
          title="Privacy Policy"
          description="Privacy Policy of Repman"
          path="/privacy-policy"
        />
        <section className="tos">
          <div className="container">
            <article className="article">
              <Section title="Privacy Policy" primary>
                Privacy Policy of BDY Sp. z o. o. Sp. k., a company incorporated
                and registered in Poland whose registered office is at Migdałowa
                4, 02-796, Warszawa referenced in this document as
                &quot;Repman&quot;.
              </Section>
              <Section noList title="Information collection and use">
                <p>
                  Repman is the only owner of the information collected on its
                  websites. The information we collect about visitors to our
                  website includes the visitor&apos;s browser type, language
                  preference, referring site, additional websites requested, and
                  the date and time of each visitor request. We also collect
                  potentially personally-identifying information like Internet
                  Protocol (IP) addresses.
                </p>
                <p>
                  The aim of Repman activity is not collecting, selling or
                  lending the information to the others. We collect this
                  information to better understand how our website visitors use
                  Repman, and to monitor and protect the security of the
                  website. We do not share, sell, rent, or trade personal
                  information with third parties for their commercial purposes.
                </p>
                <p>
                  We do not intentionally collect sensitive personal
                  information, such as social security numbers, genetic data,
                  health information, or religious information. Although Repman
                  does not request or intentionally collect any sensitive
                  personal information, we realize that you might store this
                  kind of information in your account, such as in a repository.
                  If you store any sensitive personal information on our
                  servers, you are consenting to our storage of that information
                  on our servers, which are in the United States.
                </p>
                <p>
                  We may share your personal information with your permission,
                  so we can perform services you have requested.
                </p>
                <p>
                  We do not host advertising on Repman. We may occasionally
                  embed content from third-party sites, such as YouTube, Vimeo,
                  or Disqus, and that content may include ads. While we try to
                  minimize the number of ads our embedded content contains, we
                  cant always control what third parties show.
                </p>
                <p>
                  We may share User Personal Information with a limited number
                  of third-party vendors who process it on our behalf to provide
                  or improve our service, and who have agreed to privacy
                  restrictions similar to our own Privacy Statement. Our vendors
                  perform services such as customer support ticketing
                  (Intercom), network data transmission, and other similar
                  services. When we transfer your data to our vendors under
                  Privacy Shield, we remain responsible for it.
                </p>
              </Section>
              <Section noList title="Registration & Accounts">
                <p>
                  To create an account in Repman, we will ask you for a valid
                  email address. We need your email address to authenticate you
                  in your account and send you password reset forms. An email
                  address is an example of personal information. Personal
                  information is any information about one of our users which
                  could, alone or together with other information, personally
                  identify them.
                </p>
                <p>
                  Personal Information does not include aggregated,
                  non-personally identifying information. We may use aggregated,
                  non-personally identifying information to operate, improve,
                  and optimize our website and service.
                </p>
                <p>
                  You must be at least 13 years old to use the Service. Repman
                  does not knowingly collect information from or direct any of
                  our content specifically to children under 13. If we learn or
                  have reason to suspect that you are a user who is under the
                  age of 13, we will have to close your account.
                </p>
                <p>
                  The assurance of privacy, safety and integrity of the
                  entrusted data of their users is one of the most important
                  goals of Repman. In regard to that, Repman is not going to
                  sell, lend and trade contractual data as well as the data
                  of\tregistered accounts.
                </p>
                <p>
                  We limit our use of your personal information to the purposes
                  listed in this Privacy Statement. If we need to use it for
                  other purposes, we will ask your permission first.
                </p>
              </Section>
              <Section noList title="Cookies">
                <p>
                  Cookies are series of data stored on the hard disk of the user
                  which for example include the anonymous identifier of the
                  user. The cookies are set up to remember the fact of being
                  logged in the Service if the user wished so as well as for
                  statistical aims. By using our website, you agree that we can
                  place these types of cookies on your computer or device. If
                  you disable your browser or device&apos;s ability to accept
                  cookies, you will not be able to log in or use Repman&apos;s
                  services.
                </p>
                <p>
                  Certain pages on our site may set other third-party cookies.
                  For example, we may embed content, such as videos, from
                  another site that sets a cookie. While we try to minimize
                  these third-party cookies, we can&apos;t always control what
                  cookies this third-party content sets.
                </p>
              </Section>
              <Section noList title="Google Analytics">
                <p>
                  We use Google Analytics as a third-party tracking service, but
                  we don&apos;t use it to track you individually or collect
                  personal user information. We use Google Analytics to collect
                  information about how our website performs and how our users,
                  in general, navigate through and use Repman. This helps us
                  evaluate our users&apos; use of Repman, compile statistical
                  reports on activity, and improve our content and website
                  performance.
                </p>
                <p>
                  Google Analytics gathers certain simple, non-personally
                  identifying information over time, such as your IP address,
                  browser type, internet service provider, referring and exit
                  pages, timestamp, and similar data about your use of Repman.
                  We do not link this information to any of your personal
                  information such as your username.
                </p>
                <p>
                  Repman will not, nor will we allow any third-party to, use the
                  Google Analytics tool to track our users individually, collect
                  any personal information other than IP address; or correlate
                  your IP address with your identity. Google provides further
                  information about its own privacy practices and offers a
                  browser add-on to opt out of Google Analytics tracking.
                </p>
              </Section>
              <Section noList title="Tracking">
                <p>
                  If you do not want online services to collect and share
                  certain kinds of information about your online activity from
                  third-party tracking services, you can set the Do Not Track
                  privacy preference in your browser.
                </p>
                <p>
                  We do not track your online browsing activity on other online
                  services over time and we do not permit third-party services
                  to track your activity on our site with the exception of basic
                  Google Analytics tracking and occasional user behavior
                  tracking performed with Hotjar analytics tool. The tracking
                  data is collected exclusively to improve the UX and
                  performance of the Service and website. Repman does not record
                  any personal data with Hotjar as all text entered to the
                  Service during tracking is suppressed before the data is sent
                  back to Hotjar servers.
                </p>
                <p>
                  Because we do not share this kind of data with third-party
                  services or permit this kind of third-party data collection on
                  Repman for any of our users, and we do not track our users on
                  third-party websites ourselves, we do not need to respond
                  differently to an individual browsers Do Not Track setting. If
                  you wish, you can opt out from Google Analytics tracking here,
                  and from Hotjar here.
                </p>
              </Section>
              <Section noList title="Our Vendors">
                <p>
                  Repman uses certain vendors in providing its Services. All
                  services either fully comply with GDPR regulations or are to
                  implement it shortly.
                </p>
                <p>
                  Our emails might contain a pixel tag, which is a small, clear
                  image that can tell us whether or not you have opened an email
                  and what your IP address is. We use this pixel tag to make our
                  email more effective for you and to make sure we&apos;re not
                  sending you unwanted email. If you prefer not to receive pixel
                  tags, please opt out of marketing emails.
                </p>
                <ul>
                  <li>
                    <b>
                      <a href="https://aws.amazon.com/blogs/security/all-aws-services-gdpr-ready/">
                        Amazon Web Services
                      </a>
                    </b>{' '}
                    – hosting infrastructure for the Service and SES for email
                    and SMS notifications (United States)
                  </li>
                  <li>
                    <b>
                      <a href="https://cloud.google.com/security/gdpr/">
                        Google G Suite
                      </a>
                    </b>{' '}
                    – email communication with clients (United States)
                  </li>
                  <li>
                    <b>
                      <a href="https://www.hotjar.com/legal/compliance/gdpr-commitment">
                        Hotjar
                      </a>
                    </b>{' '}
                    – UX analytics (EU/Malta)
                  </li>
                  <li>
                    <b>
                      <a href="https://docs.intercom.com/pricing-privacy-and-terms/data-protection/how-were-preparing-for-gdpr">
                        Intercom
                      </a>
                    </b>{' '}
                    – helpdesk and customer messaging platform (United States)
                  </li>
                </ul>
              </Section>
              <Section noList title="Client data">
                <p>
                  Repman uses Amazon Web Services to store client data and
                  DigitalOcean as hosting infrastructure for the Services
                  website. Physical servers for both services are located in the
                  United States.
                </p>
                <p>
                  All data uploaded by the Users belong to the Users. Repman
                  does not claim any rights to intellectual property uploaded by
                  the Users.
                </p>
                <p>
                  Despite that Repman hosts all data entered by the user, the
                  ones all the time belong to the user. Repman will never sell
                  or by purpose make accessible the data entered by the user to
                  the third-party as well as will never use them for the benefit
                  of his own business. Our procedures obey the privacy of our
                  users and their data.
                </p>
              </Section>
              <Section
                noList
                title="Access to Personally Identifying Information"
              >
                <p>
                  If your personal information changes, or if you no longer
                  desire to access or use the Service, you may correct, update,
                  amend or delete it by contacting our customer support team at{' '}
                  <b>
                    <a href="mailto:support@buddy.works">support@buddy.works</a>
                  </b>
                </p>
                <p>
                  That said, where Repman&apos;s customer for the Service is an
                  organization and a user is accessing and using the Service as
                  an authorized representative of that organization, references
                  to &quot;you&quot; and the like in this Privacy Policy generally refer
                  to the customer organization, not individual end users. In
                  such cases, Repman receives and processes information under
                  the direction of its customer and has no direct contractual
                  relationship with the individuals whose personal information
                  is or may be provided. Any such individual who seeks access,
                  or who seeks to correct, amend, or delete inaccurate data,
                  should direct his or her query to the applicable Repman
                  customer and we will respond to the customer&apos;s request within
                  a reasonable timeframe.
                </p>
              </Section>
              <Section noList title="Global Privacy Practices">
                <p>
                  Information that we collect will be stored and processed in
                  the United States in accordance with this Privacy Statement.
                  However, we understand that we have users from different
                  countries and regions with different privacy expectations, and
                  we try to meet those needs.
                </p>
                <p>
                  We provide the same standard of privacy protection to all our
                  users around the world with the same levels of notice, choice,
                  accountability, security, data integrity, access, and
                  recourse, regardless of their country of origin or location.
                  We work hard to comply with the applicable data privacy laws
                  wherever we do business. Additionally, we require that if our
                  vendors or affiliates have access to personal information,
                  they must comply with our privacy policies and with applicable
                  data privacy laws, including signing data transfer agreements.
                </p>
                <ul>
                  <li>
                    Repman provides clear methods of unambiguous, informed
                    consent at the time of data collection, when we do collect
                    your personal data.
                  </li>
                  <li>
                    We collect only the minimum amount of personal data
                    necessary, unless you choose to provide more. We do not
                    encourage you to give us more data than you are comfortable
                    sharing.
                  </li>
                  <li>
                    We offer you simple methods of accessing, correcting, or
                    deleting the data we have collected.
                  </li>
                  <li>
                    We provide our users notice, choice, accountability,
                    security, and access, and we limit the purpose for
                    processing. These are the Privacy Shield Principles, that
                    Repman fully adheres. In addition to providing our users
                    methods of unambiguous, informed consent and control over
                    their data, we participate in and comply with the Privacy
                    Shield framework, and we are committed to subject any
                    personal information we receive from the EU and EEA to the
                    Privacy Shield Principles.
                  </li>
                  <li>
                    We also comply with the principles of the Safe Harbor
                    Framework for Swiss data transfers to the US.
                  </li>
                </ul>
              </Section>
              <Section
                noList
                title="Protection of Certain Personal Information"
              >
                <p>
                  Repman discloses potentially personal information only to
                  those of its employees, contractors, and affiliated
                  organizations that (1) need to know that information in order
                  to process it on Repman&apos;s behalf or to provide services
                  available in connection with the Service and (2) have agreed
                  not to disclose it to others. Some of those employees,
                  contractors and affiliated organizations may be located
                  outside of your home country; by using Repman&apos;s Website and/or
                  the Service, you consent to the transfer of information to
                  such individuals and organizations in order to support our
                  provision to you of the Website and the Service. These
                  supporting partners may be authorized to, for example, process
                  payments on our behalf or provide customer support. Transfers
                  to subsequent third parties are covered by the provisions in
                  this Policy regarding notice and choice and the service
                  agreements with our customers. However, in each case, these
                  partners are authorized to use your personally identifying
                  information only as necessary to provide the services we
                  request.
                </p>
                <p>
                  Other than to its employees, contractors, and affiliated
                  organizations, as described above, Repman discloses personal
                  information only when required to do so by law, such as to
                  comply with a subpoena, bankruptcy proceedings, or similar
                  legal process, or when Repman believes in good faith that
                  disclosure is reasonably necessary to protect the property or
                  rights of Repman, third parties, or the public at large. If
                  Repman is involved in a merger, acquisition, or sale of all or
                  a portion of its assets, either you will be notified via email
                  and/or a prominent notice through the Service of any change in
                  ownership or uses of your personally identifying information,
                  as well as any choices you may have regarding your personal
                  information or we will require any such buyer to agree to
                  treat your personal information in accordance with this
                  Privacy Policy.
                </p>
                <p>
                  If you are a registered user of the Service and have supplied
                  your email address, Repman may occasionally send you an email
                  to tell you about new features, solicit your feedback, or just
                  keep you up to date with what&apos;s going on with Repman and our
                  products. If you send us a request (for example via a support
                  email or via one of our feedback mechanisms), we reserve the
                  right to publish it in order to help us clarify or respond to
                  your request or to help us support other users. Repman takes
                  all measures reasonably necessary to protect against the
                  unauthorized access, use, alteration, or destruction of
                  potentially personally identifying and personally identifying
                  information.
                </p>
              </Section>
              <Section noList title="Right of access and Right to be Forgotten">
                Repman doesn&apos;t ask for more personal data from our users than we
                need to provide our services to you. We provide you the ability
                to access and delete the data you have given us (e.g. you can
                remove your profile information at any time). If you want to
                erase all personal information that we have about you, please
                send a request to{' '}
                <b>
                  <a href="mailto:support@buddy.works">support@buddy.works</a>
                </b>
                . We have gone through our Privacy Statement to provide more
                context and transparency, though, so our users understand
                exactly why we ask for information and what we&apos;ll do with it.
              </Section>
              <Section noList title="Changes to Privacy Policy">
                If we are going to change our Privacy Policy we will inform our
                users about this fact, by sending an appropriate email to the
                email address of the owner&apos;s account registered in our Service.
              </Section>
            </article>
          </div>
        </section>
      </Layout>
    </>
  );
}
